<template>
    <div id="div_service">
        <div v-for="group in groupedRoles" :key="group">
            <p class="p_keytag">{{ group.group }}</p>
            <ul>
                <li v-for="role in group.roles" :key="role" class="li_role">
                    {{ role.venue }}, {{ role.year }} 
                    <span v-if="role.link">(<a :href="role.link">link</a>)</span>
                    <br> 
                    <span class="li_award" v-if="role.award">({{ role.award }})</span>
                </li>
                
            </ul>                
        </div>
    </div>
</template>

<script>
// Imports
import jsonService from '../assets/service.json';

export default {
    data () {
        return {
            roles: [],
            sortedBy: "role"
        }
    },
    created() {
        this.roles = jsonService;
    },
    methods: {
    },
    computed: {
        groupedRoles: function(){
            var sortKey = this.sortedBy;
            var roleGroup = []
            for(var i=0; i<this.roles.length; i++) {
                var groupId = this.roles[i][sortKey]
                var foundGroup = false;
                for(var j=0; j<roleGroup.length; j++) {
                    if(roleGroup[j]['group']==groupId) {
                        foundGroup = true;
                        roleGroup[j]['roles'].push(this.roles[i]); 
                    }
                }
                if(!foundGroup) {
                    roleGroup.push({'group': groupId, 'roles': [this.roles[i]]})
                }
            }
            return roleGroup;
        }
    }
}
</script>

<style scoped>
#div_service {
    margin: 15px auto;
    /* max-width: 700px; */
    padding-left: 10px;
    border-left: 2px solid #eeeeee;
    /*font-family: 'Helvetica,Arial,sans-serif';*/
}

.p_keytag {
    font-weight: bold;
    font-size: 15px;
}
.li_role{
    /*font-style: italic;*/
    font-size: 14px;
}
.li_award{
    font-size: 16px;
    font-weight: bold;
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/service.vue